module.exports = __webpack_public_path__ + "static/media/ic_edit.c73c992e.svg";